module.exports = __webpack_public_path__ + "static/media/wishlist-share.ed6f58e4.png";